import React, { useState, useEffect, useRef } from 'react';
import Header from '../home/components/Header.tsx';
import OverviewTab from './OverviewTab.tsx';
import HoldingsTab from './HoldingsTab.tsx';
import TradingTab from './TradingTab.tsx';
import RecommendationsTab from './RecommendationsTab.tsx';
import TabNavigation from './TabNavigation.tsx';
import { useNavigate } from 'react-router-dom';
import { qryCopilotValueApi, getCopilotValueByTaskIdApi } from '@/api/copilot';
import { EXTERNAL_USER_ID } from '@/config/env';
import { ClipLoader } from 'react-spinners';
import { TotalData } from './index.type';
import { defaultTotalData } from './defaultTotalData';
// 修复：用 forwardRef 包裹，明确 props 和 ref 类型（避免 any）
const DiagnosisPage = React.forwardRef(() => {
  const [loading, setLoading] = useState<boolean>(true);
  const [totalData, setTotalData] = useState<TotalData>(defaultTotalData);
  const hasFetched = useRef(false);

  const navigate = useNavigate();

  // 获取Copilot数据
  const fetchCopilotData = async () => {
    try {
      setLoading(true);
      const response = await qryCopilotValueApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 0
      });
      console.log(response);
      if (response) {
        const pUseAll = [1, 2, 3].map(reqType => {
          return getCopilotValueByTaskIdApi({
            externalUserId: EXTERNAL_USER_ID,
            reqType,
            taskId: response
          });
        });

        Promise.allSettled(pUseAll).then(results => {
          console.log('获取Copilot数据成功:', results);
          results.forEach((result, index) => {
            if (result.status === 'fulfilled') {
              if (index === 0) {
                const { investment_behavior_analysis } = result.value || {};
                setTotalData(prev => ({
                  ...prev,
                  investment_behavior_analysis
                }));
              }
              if (index === 1) {
                const resultData = result.value || {};
                const { customerInfo } = resultData;
                const info = (customerInfo && customerInfo[0]) || {};
                const {
                  sharpe_ratio,
                  return_rate_last_month,
                  return_rate_last_3months,
                  return_rate_last_6months,
                  anualized_return_rate,
                  vs_csi300,
                  monthly_avg_trades,
                  annualized_turnover_rate,
                  trading_activity_rank,
                  max_profit_take,
                  holding_product_review,
                  holding_fund_count,
                  largest_holding_fund,
                  holding_industry_count,
                  largest_industry_ratio,
                  top5_industry_ratio_details,
                  top5_holding_ratio,
                  top10_holding_ratio,
                  largest_holding_style,
                  excess_return_last_6months,
                  style_dimension,
                  trading_win_rate,
                  industry_allocation_profit,
                  stock_holding_profit,
                  buying_preference_ratio,
                  selling_preference_ratio,
                  // max_profit_take,
                  max_stop_loss,
                  avg_profit_take,
                  avg_stop_loss,
                  annual_turnover_rate,
                  // monthly_avg_trades,
                  avg_holding_period
                } = info || {};
                setTotalData(prev => ({
                  ...prev,
                  sharpe_ratio,
                  return_rate_last_month,
                  return_rate_last_3months,
                  return_rate_last_6months,
                  anualized_return_rate,
                  vs_csi300,
                  monthly_avg_trades,
                  annualized_turnover_rate,
                  trading_activity_rank,
                  max_profit_take,
                  holding_product_review,
                  holding_fund_count,
                  largest_holding_fund,
                  holding_industry_count,
                  largest_industry_ratio,
                  top5_industry_ratio_details,
                  top5_holding_ratio,
                  top10_holding_ratio,
                  largest_holding_style,
                  excess_return_last_6months,
                  style_dimension,
                  trading_win_rate,
                  industry_allocation_profit,
                  stock_holding_profit,
                  buying_preference_ratio,
                  selling_preference_ratio,
                  // max_profit_take,
                  max_stop_loss,
                  avg_profit_take,
                  avg_stop_loss,
                  annual_turnover_rate,
                  // monthly_avg_trades,
                  avg_holding_period
                }));
              }
              if (index === 2) {
                const resultData = result.value || {};
                const {
                  market_analysis,
                  suggestion,
                  cash_before,
                  stable_before,
                  aggressive_before,
                  cash_after,
                  stable_after,
                  aggressive_after,
                  advantage1_title,
                  advantage1_desc,
                  advantage2_title,
                  advantage2_desc,
                  advantage3_title,
                  advantage3_desc,
                  return_res,
                  pullback,
                  recommend_cash_name1,
                  recommend_cash_return1,
                  recommend_cash_percent1,
                  recommend_cash_name2,
                  recommend_cash_return2,
                  recommend_cash_percent2,
                  recommend_stable_name1,
                  recommend_stable_return1,
                  recommend_stable_percent1,
                  recommend_stable_name2,
                  recommend_stable_return2,
                  recommend_stable_percent2,
                  recommend_aggressive_name1,
                  recommend_aggressive_return1,
                  recommend_aggressive_percent1,
                  recommend_aggressive_name2,
                  recommend_aggressive_return2,
                  recommend_aggressive_percent2
                } = resultData;

                setTotalData(prev => ({
                  ...prev,
                  market_analysis,
                  suggestion,
                  cash_before,
                  stable_before,
                  aggressive_before,
                  cash_after,
                  stable_after,
                  aggressive_after,
                  advantage1_title,
                  advantage1_desc,
                  advantage2_title,
                  advantage2_desc,
                  advantage3_title,
                  advantage3_desc,
                  return_res,
                  pullback,
                  recommend_cash_name1,
                  recommend_cash_return1,
                  recommend_cash_percent1,
                  recommend_cash_name2,
                  recommend_cash_return2,
                  recommend_cash_percent2,
                  recommend_stable_name1,
                  recommend_stable_return1,
                  recommend_stable_percent1,
                  recommend_stable_name2,
                  recommend_stable_return2,
                  recommend_stable_percent2,
                  recommend_aggressive_name1,
                  recommend_aggressive_return1,
                  recommend_aggressive_percent1,
                  recommend_aggressive_name2,
                  recommend_aggressive_return2,
                  recommend_aggressive_percent2
                }));
              }
            }
          });
        });
      }
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  // 组件挂载时获取数据
  useEffect(() => {
    console.log('HomePage 组件挂载');
    // 防止在 StrictMode 下重复调用
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchCopilotData();
    }
  }, []);

  const tabs = [
    { label: '总览', value: 'overview' },
    { label: '持仓分析', value: 'holdings' },
    { label: '交易行为', value: 'trading' },
    { label: '优化推荐', value: 'recommendations' }
  ];
  const [activeTab, setActiveTab] = useState<string>('overview');

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="relative mx-auto flex h-screen flex-col overflow-hidden bg-gradient-to-b from-blue-50 via-blue-50 to-purple-100">
      <Header goBack={goBack}>
        <div className="text-lg font-semibold leading-none tracking-tight">
          持仓深度诊断
        </div>
      </Header>
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onUpdateActiveTab={setActiveTab}
      />
      {loading && (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
          <ClipLoader color="#1677FF" />
        </div>
      )}
      <div
        className={`relative space-y-3 overflow-hidden px-4 ${
          loading ? 'opacity-50' : 'opacity-100'
        } transition-opacity duration-300`}
      >
        {activeTab === 'overview' && <OverviewTab totalData={totalData} />}
        {activeTab === 'holdings' && <HoldingsTab totalData={totalData} />}
        {activeTab === 'trading' && <TradingTab totalData={totalData} />}
        {activeTab === 'recommendations' && (
          <RecommendationsTab totalData={totalData} />
        )}
      </div>
    </div>
  );
});

export default DiagnosisPage;
